// extracted by mini-css-extract-plugin
export default {"root":"PriceFilterPopup_root__eQrkR","icon":"PriceFilterPopup_icon__wxTv1"};